<placeme-layout-seo [seo]="'showcasesPage.seo' | translate">
  <placeme-jumbotron [seo]="'showcasesPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content">
    <markdown class="page-markdown" [data]="'showcasesPage.content' | translate"></markdown>

    <div class="container">
      <a class="card" *ngFor="let item of showcases; trackBy: trackBySlug" [routerLink]="[item?.slug] | localize">
        <div class="card__img">
          <img
            *ngIf="item"
            [src]="
              item?.seo
                | seoImageUrl
                  : {
                      text: false,
                      format: 'rectangle',
                      logo: true,
                      category: item?.__typename
                    }
            "
            [alt]="item?.seo?.title"
            [title]="item?.seo?.title"
          />
        </div>
        <div class="card__container">
          <h3 class="card__container__title">{{ item?.seo?.title }}</h3>
          <p class="card__container__description">{{ item?.seo?.description }}</p>
        </div>
      </a>
    </div>
    <p *ngIf="showcases && !showcases.length" class="showcases__empty">{{ 'showcasesPage.emptyContent' | translate }}</p>
  </section>
</placeme-layout-seo>
